import React from "react";
import { useForm, FormProvider as FormContext } from "react-hook-form";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers";

const validationSchema = Yup.object().shape({
  eventName: Yup.string().required("Event name is required."),
  eventLocation: Yup.string().required("Event location is required."),
  eventDateTime: Yup.string().required("Event date is required."),
  eventEndDateTime: Yup.string().required("Event end date is required."),
  eventTagline: Yup.string().required("Event tagline is required."),
  zoomLink: Yup.string().url("This should be a valid URL."),
  eventDescription: Yup.string()
    .required("Event description is required.")
    .max(1000, "Event description cannot cross 1000 characters limit."),
  eventDisclaimers: Yup.string().max(
    1000,
    "Event disclaimers cannot cross 1000 characters limit."
  ),
  learningIcon_1_desc: Yup.string().required(
    "Learning Icon 1 description is required."
  ),
  learningIcon_2_desc: Yup.string().required(
    "Learning Icon 2 description is required."
  ),
  hostName: Yup.string().required("Host name is required."),
  hostCredentials: Yup.string().required("Host credentials are required."),
  hostDescription: Yup.string()
    .required("Host description is required.")
    .max(1000, "Host description cannot cross 1000 characters limit."),
});

const AddEventFormContext = ({ children }) => {
  const methods = useForm({
    resolver: yupResolver(validationSchema)
  });

  return <FormContext {...methods}>{children}</FormContext>;
};

export default AddEventFormContext;
